<template>
  <el-form class="bid-form" ref="form" :model="{}" :rules="rules" label-width="200px">
    <el-form-item label="优化目标">
      <el-radio-group v-model="outterForm.bidtype">
        <el-radio-button ghost :label="3">转化</el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="转化名称">
      <el-input readonly placeholder="系统自动创建转化名称，无需填写"></el-input>
    </el-form-item>

    <el-form-item label="出价模式">
      <el-radio-group v-model="outterForm.ocpc.ocpcLevel">
        <el-radio-button ghost :label="2">转化出价</el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="转化类型">
      <el-select v-model="outterForm.ocpc.transType" @change="onBidTypeChange">
        <!-- transType https://dev2.baidu.com/content?sceneType=0&pageId=100052&nodeId=73&subhead= -->

        <!-- 小程序平台 -->
        <template v-if="innerForm.ch_platform_id === 3">
          <el-option label="登录" :value="49"> </el-option>
          <el-option label="付费" :value="26"> </el-option>
        </template>

        <template v-else>
          <el-option label="激活" :value="4"> </el-option>
          <el-option label="付费" :value="26"> </el-option>
        </template>
      </el-select>

      <span v-if="outterForm.ocpc.transType === 26" style="margin-left: 10px">
        <!-- 开启深度转化出价时，取消勾选且禁用 -->
        <el-checkbox v-model="outterForm.ocpc.checkPaidTimes" :disabled="outterForm.ocpc.deep_bid_mode">优化付费次数</el-checkbox>
        <Tooltip placement="top" content="按照付费次数优化不允许叠加选择ROI优化"> <Icon type="md-information-circle" /> </Tooltip>
      </span>
    </el-form-item>

    <el-form-item label="推广落地页" prop="lpUrl" v-if="innerForm.landing_type === 'LINK'">
      <div class="external-page">
        <el-input
          class="page-url"
          v-model="outterForm.ocpc.lpUrl"
          :disabled="outterForm.ocpc.innerUrl"
          placeholder="手动填写落地页或者使用系统内部生成落地页"
        ></el-input>
        <el-checkbox v-model="outterForm.ocpc.innerUrl" @change="onLandpageTypeChange">使用系统内部落地页</el-checkbox>
      </div>
    </el-form-item>

    <el-form-item label="目标转化出价" prop="bid">
      <el-radio-group v-model="outterForm.ocpc.bid_range">
        <el-radio-button ghost :label="0">固定金额</el-radio-button>
        <el-radio-button ghost :label="1">随机金额</el-radio-button>
      </el-radio-group>

      <div class="range-value" style="margin-top: 10px" v-if="outterForm.ocpc.bid_range">
        <InputRange v-model="outterForm.ocpc.bid_num_range" placeholder="金额">
          <span slot="suffix">元/转化</span>
        </InputRange>
      </div>

      <div class="single-value" v-else>
        <el-input v-model="outterForm.ocpc.ocpcBid" placeholder="输入转化价格"></el-input>
        <span class="suffix"> 元/转化</span>
      </div>
    </el-form-item>

    <el-form-item label="深度转化出价">
      <el-switch v-model="outterForm.ocpc.deep_bid_mode" @change="onDeepBidModeChange"></el-switch>
    </el-form-item>

    <template v-if="outterForm.ocpc.deep_bid_mode">
      <!-- 激活深度优化方式 -->
      <template v-if="outterForm.ocpc.transType === 4">
        <el-form-item label="深度优化方式">
          <el-radio-group v-model="outterForm.ocpc.optimizeDeepTrans">
            <el-radio-button ghost :label="1">优化深度转化</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="深度转化目标">
          <el-select v-model="outterForm.ocpc.deepTransType">
            <el-option label="付费" :value="26"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="深度转化目标出价" prop="deep-bid">
          <el-radio-group v-model="outterForm.ocpc.deep_bid_range">
            <el-radio-button ghost :label="0">固定金额</el-radio-button>
            <el-radio-button ghost :label="1">随机金额</el-radio-button>
          </el-radio-group>

          <div class="range-value" style="margin-top: 10px" v-if="outterForm.ocpc.deep_bid_range">
            <InputRange v-model="outterForm.ocpc.deep_deepbid_num_range" placeholder="金额">
              <span slot="suffix">元/转化</span>
            </InputRange>
          </div>

          <div class="single-value" v-else>
            <el-input v-model="outterForm.ocpc.deepOcpcBid" placeholder="输入转化价格"></el-input>
            <span class="suffix"> 元/转化</span>
          </div>
        </el-form-item>
      </template>

      <!-- 付费深度优化方式 -->
      <template v-if="outterForm.ocpc.transType === 26">
        <el-form-item label="深度优化方式">
          <el-radio-group v-model="outterForm.ocpc.useRoi">
            <el-radio-button ghost :label="1">优化ROI</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="ROI系数" prop="deep-bid">
          <el-input v-model="outterForm.ocpc.roiRatio" placeholder="请输入系数，范围0.01 - 100"></el-input>
        </el-form-item>
      </template>
    </template>
  </el-form>
</template>
<script>
import InputRange from '@/views/edit/kuaishou/components/input-range'
import { makeBudgetRules } from './data/form-rules.js'

export default {
  components: { InputRange },
  data() {
    return {
      rules: { ...makeBudgetRules.call(this) }
    }
  },
  computed: {
    formData() {
      return this.$store.getters['Baidu/currTaskParams']
    },
    outterForm: {
      get() {
        return this.formData.outterForm
      },
      set(form) {
        this.$store.commit('Baidu/UPDATE_OUT_PARAMS', form)
      }
    },
    innerForm() {
      return this.formData.innerForm || {}
    }
  },
  methods: {
    /**
     * @description: 20221130 按照付费次数优化不允许叠加选择ROI优化
     */
    onDeepBidModeChange() {
      this.unCheckPaidTimes()

      this.toggleTransType()
    },
    /**
     * @description: 清除一些校验信息
     * @return {*}
     */
    onBidTypeChange() {
      this.$refs.form.clearValidate()
      this.onDeepBidModeChange()
    },
    /**
     * @description: 根据转化类型默认选中一些深度参数
     * @return {*}
     */
    toggleTransType() {
      const newForm = this.outterForm

      newForm.ocpc.deep_bid_range = 0 // 切换到固定金额
      newForm.ocpc.deep_deepbid_num_range = ['', ''] // 清空随机金额
      newForm.ocpc.deepOcpcBid = '' // 清空固定金额
      newForm.ocpc.roiRatio = '' // 清空roi系数

      this.outterForm = newForm
    },
    /**
     * @description: 20221130 按照付费次数优化不允许叠加选择ROI优化
     * @description: 打开深度转化出价开关时，取消勾选优化付费次数
     */
    unCheckPaidTimes() {
      const newForm = this.outterForm
      newForm.ocpc.checkPaidTimes = false
      // https://dev2.baidu.com/content?sceneType=0&pageId=100052&nodeId=73
      newForm.ocpc.transTypeAttribute = 2
      this.outterForm = newForm
    },

    /**
     * @description: 勾选使用内部落地页时清空已填写结果
     * @param {*} v
     * @return {*}
     */
    onLandpageTypeChange(v) {
      if (v) {
        const newForm = this.outterForm
        newForm.ocpc.lpUrl = ''
        this.outterForm = newForm
      }
    },

    formValidate() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            resolve()
          } else {
            reject(new Error('budget'))
          }
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.bid-form {
  max-width: 1000px;

  .range-value,
  .single-value {
    margin-top: 10px;
  }
  .single-value {
    display: flex;
    align-items: center;

    .el-input {
      width: 120px;
    }
    .suffix {
      margin-left: 10px;
      font-size: 12px;
    }
  }
  // 外部落地页
  .external-page {
    display: flex;
    .page-url {
      margin-right: 10px;
    }
  }
}
</style>
